


const OSNOVNA = 4;
const PREDSJETVENA = 6;
const PRVA_PRIHRANA = 8;
const DRUGA_PRIHRANA = 10;
const MELIORATIVNA = 12;
const GENERAL_NULL = null;
const GENERAL_UNDEFINED = undefined;

export default {
    OSNOVNA: OSNOVNA,
    PREDSJETVENA: PREDSJETVENA,
    PRVA_PRIHRANA: PRVA_PRIHRANA,
    DRUGA_PRIHRANA: DRUGA_PRIHRANA,
    MELIORATIVNA: MELIORATIVNA,
    GENERAL_NULL: GENERAL_NULL,
    GENERAL_UNDEFINED: GENERAL_UNDEFINED
}